import { useCallback } from "react";

import { apiUrls } from "config";
import { useCompute } from "api";

import { useGetSpec } from "./store";
import { validateSpec } from "./validator";

export const useGetCreateStackedData = (fileIds: string[]) => {
  const url = apiUrls.create_data_stack;
  const compute = useCompute(url, false);

  const spec = useGetSpec(fileIds);

  return useCallback(
    async (newName: string) => {
      if (!newName) {
        throw Error("Name is mandatory!");
      }

      const errors = validateSpec(spec);
      if (Object.keys(errors).length >= 1) {
        throw Error(`Invalid Spec: ${JSON.stringify(errors)}`);
      }

      const finalSpec = { name: newName, ...spec };
      const resp = await compute({ data: finalSpec });
      if (!resp.result) {
        throw Error("Unable to flatten data!!");
      }
      const { completed, data, error_message, message } = resp.result;
      if (!completed) {
        throw Error(error_message || message || "Unable to flatten data!");
      }

      return data[0] as string;
    },
    [spec, url, compute]
  );
};
